import { filter } from "@msuite/utils/array";
import { useMemo } from "react";

interface UseSectionFilter<T> {
	filtered: T[];
	original: T[] | undefined;
}

export function useSectionFilter<
	TItem,
	TKey extends string = "data",
	TSection extends Record<TKey, TItem[]> = Record<TKey, TItem[]>,
>(
	original: TSection[] | undefined,
	searchValue: string | null,
	dataKey: TKey = "data" as TKey,
): UseSectionFilter<TSection> {
	/** Filtering */
	const filtered = useMemo(() => {
		if (!original) return [];
		if (!searchValue) return original;
		return original.reduce<TSection[]>((acc, section) => {
			const items = filter(section[dataKey], searchValue);
			if (items.length > 0) acc.push({ ...section, [dataKey]: items });
			return acc;
		}, []);
	}, [original, searchValue, dataKey]);

	return { filtered, original };
}
